import { Icon } from '@chakra-ui/react';

export const QuickBooks = (props) => (
  <Icon viewBox="0 0 129 117" fill="none" {...props}>
    <path
      d="M0.599998 58.2C0.599998 77.2 16 92.6 35 92.6H39.9V79.8H35C23.1 79.8 13.4 70.1 13.4 58.2C13.4 46.3 23.1 36.6 35 36.6H46.8V103.3C46.8 110.3 52.5 116.1 59.6 116.1V23.9C59.6 23.9 46.4 23.9 35 23.9C15.9 23.9 0.599998 39.3 0.599998 58.2V58.2ZM93.8 23.9H88.9V36.7H93.8C105.7 36.7 115.4 46.4 115.4 58.3C115.4 70.2 105.7 79.9 93.8 79.9H82C82 79.9 82 14.4 82 13.2C82 6.19999 76.3 0.399994 69.2 0.399994V92.7H93.8C112.8 92.7 128.2 77.3 128.2 58.3C128.2 39.3 112.8 23.9 93.8 23.9V23.9Z"
      fill="currentColor"
    />
  </Icon>
);
